import React, { useState } from 'react';
import axios from 'axios';

const ForgotPassword: React.FC = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const apiUrl = process.env.REACT_APP_API_URL;

    const handleForgotPassword = async () => {
        try {
            await axios.post(`${apiUrl}/Admin/forgotPassword`, { email });
            setMessage('Password reset link has been sent to your email.');
        } catch (error) {
            setError('Failed to send password reset link');
        }
    };

    return (
        <div className='reset-password-section'>
        
            {message && <p style={{ color: 'green' }}>{message}</p>}
            {error && <p style={{ color: 'red' }}>{error}</p>}
            <div className='reset-password-form'>
                <input
                   className='reset-password-form__input'
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                />
              <div className='reset-password-form-reset-section'>
              <button className='reset-password-form__button' onClick={handleForgotPassword}>Send Reset Link</button>
              </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
